import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { AppHeader } from './AppHeader';
import { BottomNav } from './BottomNav';

/**
 * Layout para todas las páginas autenticadas.
 * - Redirige a /login si no hay sesión.
 * - Inyecta AppHeader fijo arriba + BottomNav fijo abajo.
 * - El contenido de cada página se renderiza en <Outlet />.
 */
export function AppLayout() {
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="min-h-screen bg-surface dark:bg-dark-surface">

      {/* Header fijo arriba */}
      <AppHeader user={user} notificationCount={3} />

      {/* Contenido de la página — con espacio para header (56px) y bottom nav (64px) */}
      <main className="pt-14 pb-16 min-h-screen bg-surface dark:bg-dark-surface">
        <Outlet context={user} />
      </main>

      {/* Nav fija abajo */}
      <BottomNav role={user.role} />

    </div>
  );
}
